import axios from "axios";
import { GURL } from "./global";

export const GetAllProvinces = () => {
  const url = `${GURL}/Notice/v1/Province`;
  //console.log(url);
  return axios.get(url);
};
export const GetAllCitiesByProvinceId = (id: any) => {
  const url = `${GURL}/Notice/v1/Province/GetAllCities/${id}?provinceId=${id}`;
  //console.log(url);
  return axios.get(url);
};
